import cx from 'classnames';
import React, { useState } from 'react';

import commentAsset from 'img/video-player/comment_stroke_default.svg';
import activeCommentAsset from 'img/video-player/comment_stroke_hover.svg';

import EnsureInsideContainer from '../ensure-inside-container';

import styles from './styles.module.less';

const VIDEO_ICON_PADDING = 8;

const TimelineVideoIcon = props => {
  const {
    commentCount,
    commentBarRef,
    percentageLeft,
    onClick,
    iconClass,
  } = props;
  const [hovered, setHovered] = useState(false);

  let displayLength = commentCount;

  if (displayLength < 2) {
    // don't draw anything for a single reply
    displayLength = '';
  } else if (displayLength > 9) {
    // don't draw multi digit lengths
    displayLength = '9+'; // TODO: figure this behaviour out with Tony
  }

  const mouseEnter = () => {
    setHovered(true);
    props.onMouseEnter();
  };

  const mouseLeave = () => {
    setHovered(false);
    props.onMouseLeave();
  };

  const handleClick = e => {
    e.stopPropagation();
    onClick();
  };

  const onMouseDown = e => {
    // We need to catch the mouseDown event, otherwise the seek bar will get it and jump the playback.
    e.stopPropagation();
  };

  return (
    <EnsureInsideContainer
      parentRef={commentBarRef}
      percentageLeft={percentageLeft}
      commentBarRer={commentBarRef}
      horizontalPadding={VIDEO_ICON_PADDING}
    >
      <div
        className={cx(styles.videoIcon, 'reaction', iconClass)}
        onClick={handleClick}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
        onMouseDown={onMouseDown}
      >
        <img
          className={styles.commentIcon}
          src={hovered ? activeCommentAsset : commentAsset}
        />
        <span className={styles.threadLength} alignment="center">
          {String(displayLength)}
        </span>
      </div>
    </EnsureInsideContainer>
  );
};

export default TimelineVideoIcon;
